import { render, staticRenderFns } from "./GalleryComponent.vue?vue&type=template&id=55c378bc"
import script from "./GalleryComponent.vue?vue&type=script&lang=js"
export * from "./GalleryComponent.vue?vue&type=script&lang=js"
import style0 from "./GalleryComponent.vue?vue&type=style&index=0&id=55c378bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports